module.exports = __webpack_public_path__ + "img/rumblefish_white_logo.978e0135.svg";